export default __webpack_public_path__ + "pgnv-assets/2c5dc9dd2648b6e7a1292c9d2fbcf774.png";